import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

export class TwRealityChecksApiService {
	static baseUrl(context: ApiRequestContextData | null) {
		return `${WEBPACK_BASE_ADDRESS}${context?.agencyKey}/tw-reality-checks/`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] =
			"application/x-www-form-urlencoded";

		return appHeaders;
	};

	static async resolveRealityCheckData(
		userId: string,
		logout: boolean = false
	): Promise<void> {
		const context = getApiRequestContext();

		return await httpClient.get(
			`${this.baseUrl(context)}${userId}?logout=${logout}`,
			this.getRequestHeaders(context),
			{ responseType: "raw" }
		);
	}
}
